<!--
 * @Author: 李明明
 * @Date: 2024-01-30 11:16:15
 * @LastEditTime: 2024-10-17 11:18:34
 * @LastEditors: 李明明
 * @Description: 
 * @FilePath: /ykt-micro-main/src/components/public/foot.vue
 * 代码版权方：'政府采购信息网'
-->

<template>
  <div class="footer" ref="aa">
    <div class="footerWrap">
      <p class="support">技术支持：北京熹艺文传媒科技有限公司</p>

      <p>地址：北京市大兴区欣宝街2号院一区7号楼（鸿坤金融谷2号地A3楼）</p>
      <a href="#/help/touch" class="footer_link">
        <i class="iconfont iconlianxiwomen1"></i>
        <span>联系我们</span>
      </a>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 56px;
  background: #418ec6;
  position: relative;
  z-index: 999;
  .footerWrap {
    margin: 0 auto;
    width: 1200px;
    text-align: center;
    height: 56px;
    .support {
      margin-right: 30px;
    }
    p {
      font-family: MicrosoftYaHei;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 55px;
      letter-spacing: 1px;
      color: #ffffff;
      display: inline-block;
      margin-bottom: 0;
      vertical-align: middle;
    }
    a {
      color: #fbfcfe;
      text-decoration: none;
      margin-left: 30px;
      vertical-align: midle;
      span {
        font-family: MicrosoftYaHei;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        line-height: 56px;
        vertical-align: middle;
      }
      i {
        vertical-align: middle;
        margin-right: 4px;
      }

      &:hover {
        color: #df3031;
      }
    }
  }
}
</style>
